import { Component, OnInit } from '@angular/core';
import { CertificateTypeDTO } from '../../model/certificate-type.entity';
import { Dropdown } from 'primeng/dropdown';
import { AdminService } from '../../services/admin.service';
import { CommonService } from '../../../core/common/services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'tandc-certificate-type-standard',
  templateUrl: './certificate-type-standard.component.html',
})
export class CertificateTypeStandardComponent implements OnInit {

  standardList: Dropdown[] = [];
  model: CertificateTypeDTO = new CertificateTypeDTO();
  showModal: boolean = false;
  certificateType: CertificateTypeDTO = new CertificateTypeDTO();

  constructor(private service: AdminService,
    private commonService: CommonService,
    private translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute,) { }

  ngOnInit(): void {
    this.getAll();
    const id = this.route.snapshot.paramMap.get('id');
    if (id && Number(id) > 0) {
      this.service.getCertificateTypeById(Number(id)).subscribe((x) => {
        this.model = x.value;
      });
    }
  }

  getAll() {
    this.service.getStandard().subscribe((x) => {
      this.standardList = x.value;
    });

  }

  save(data: CertificateTypeDTO) {
    if (data.id > 0) {
      this.service.updateCertificateType(data).subscribe((res: any) => {
        if (res) {
          this.showModal = !this.showModal;
          this.commonService.successMessage(
            this.translate.instant('Alerts.UpdatedSuccessfully')
          );
          this.router.navigate(['admin/certificatetype']);
          this.getAll();
        }
      })
    }
    else {
      this.service.saveCertificateType(data).subscribe((res: any) => {
        if (res) {
          this.showModal = !this.showModal;
          this.commonService.successMessage(
            this.translate.instant('Alerts.SavedSuccessfully')
          );
          this.router.navigate(['admin/certificatetype']);
          this.getAll();
        }
      });
    }
  }

  cancel() {
    this.router.navigate(['admin/certificatetype']);
  }

  selectedStandards(value: any) {
    let std = this.standardList.find(item => item.id == value);
    return std?.name;

  }

  delete(standard: any, model: any) {
    const index = model.standard.indexOf(standard);
    this.model.standard = this.model.standard.filter(x => x != standard);
  }

}
